import { render } from "./HeroiconsOutlineCurrencyYen.vue?vue&type=template&id=6b29e3df"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyYen.vue"]])

export default __exports__